var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useLang } from '../hooks/use-lang';
import { useSite } from '../hooks/use-site';
import { ContentNode } from './content-node';
var cls = classNames('site-terms-privacy-content');
export var SiteTermsPrivacyContentDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n\n    *:first-child {\n      margin-top: 0;\n    }\n  "], ["\n    font-size: ", ";\n\n    *:first-child {\n      margin-top: 0;\n    }\n  "])), theme.FONT_SIZE(14))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TermsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TermsContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var PrivacyPolicyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var PrivacyPolicyContentStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SiteTermsPrivacyContent',
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled.h2(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  PrivacyPolicy: styled.section(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), PrivacyPolicyStyles),
  PrivacyPolicyContent: styled(ContentNode)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), PrivacyPolicyContentStyles),
  Terms: styled.section(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TermsStyles),
  TermsContent: styled(ContentNode)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TermsContentStyles)
};
export var SiteTermsPrivacyContent = function (props) {
  var _a, _b;
  var componentProps = useComponentProps(My.NAME, SiteTermsPrivacyContentDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children;
  var t = useLang();
  var site = useSite();
  var hasTerms = (_a = site.termsAndConditions) === null || _a === void 0 ? void 0 : _a.text;
  var hasPrivacyPolicy = (_b = site.privacyPolicy) === null || _b === void 0 ? void 0 : _b.text;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasTerms && React.createElement(My.Terms, null, React.createElement(My.Header, null, t('Terms and Conditions')), React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: hasTerms
    }
  })), hasPrivacyPolicy && React.createElement(My.PrivacyPolicy, null, React.createElement(My.Header, null, t('Privacy Policy')), React.createElement(My.PrivacyPolicyContent, {
    entity: site.privacyPolicy
  })), children);
};
SiteTermsPrivacyContent.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;